// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d4ab2663","192":"1e0d0d3a","423":"4be4aeaa","787":"61e7ff9e","795":"7d369bfc","935":"4173ae2e"}[chunkId] + ".chunk.js";
};